import { FC, useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import WithHeaderandFooter from "../hoc";

import { PublicRoutes, AuthenticatedRoutes, ManufacturerRoutes } from "./AppRoutes";
import HubSplashScreen from "src/pages/splashscreen";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";
import IdleSession from "src/components/idleSession";
import MyQCHomePage from "src/pages/myQCHomePage";
import MyQCResourcePage from "src/pages/myQCResourcePage";


const HubRoutes: FC = () => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);
  const location = useLocation();


  useEffect(() => {
    if (isAccordianShown)
      changeAccordianVisibility();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>      
    
    <Routes>
      {isUserAuthorized ? (
        isManufacturer ?
          ManufacturerRoutes.map((route) => (
            <Route
              key={route.route}
              path={route.route}
              index={route.isIndex}
              element={
                route.removeHeaderandFooter === false ?
                  <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
              }
            />
          )) :
          AuthenticatedRoutes.map((route) => (
            <Route
              key={route.route}
              path={route.route}
              index={route.isIndex}
              element={
                route.removeHeaderandFooter === false ?
                  <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
              }
            />
          ))
      ) : (
        PublicRoutes.map((route) => (
          <Route
            key={route.route}
            path={route.route}
            index={route.isIndex}
            element={
              route.removeHeaderandFooter === false ?
                <WithHeaderandFooter WrappedComponent={route.component} /> : <route.component />
            }
          />
        ))
      )}

      <Route path="/resources" element={<MyQCResourcePage />} />
      <Route path="/" element={<MyQCHomePage />} />
      <Route path="*" element={<HubSplashScreen />} />
    </Routes>
      {isUserAuthorized && 
        <IdleSession idleTime={isManufacturer ? 1000 * 60 * Number(process.env.REACT_APP_MANUFACTURER_SESSION_IN_MINUTES || 1) : 1000 * 60 * Number(process.env.REACT_APP_HCP_SESSION_IN_MINUTES || 1)} />
      }
    </>
  );
};

export default HubRoutes;
